'use strict';

require('../../modules/es6.promise');

require('../../modules/es7.promise.finally');

module.exports = require('../../modules/_core').Promise['finally'];